import { render } from "./ErrorBlock.vue?vue&type=template&id=65a19d99"
import script from "./ErrorBlock.vue?vue&type=script&lang=js"
export * from "./ErrorBlock.vue?vue&type=script&lang=js"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__